import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';

export interface VehicleType {
    _id: string;
    designation: string;
    price: number;
    priceType: number;
    crudStatus: number;
    usageCount?: {
        total: number;
        vehicles: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

export interface VehicleTypesResponse {
    message: string;
    data: VehicleType[];
}

export interface VehicleTypeResponse {
    message: string;
    data: VehicleType;
}

export interface GetVehiclesTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateVehicleTypeBody {
    designation: string;
    price: number;
    priceType: number;
    crudStatus?: number;
    displayOrder?: number| null;
}

export interface UpdateVehicleTypeBody {
    designation?: string;
    price?: number;
    priceType?: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export const getAllVehicleTypes = async (queries?: GetVehiclesTypesQueries): Promise<VehicleTypesResponse> => {
    const response: AxiosResponse<VehicleTypesResponse> = await apiClient.get('/vehicle-types', { params: queries });
    return response.data;
};

export const getVehicleTypeById = async (id: string): Promise<VehicleTypeResponse> => {
    const response: AxiosResponse<VehicleTypeResponse> = await apiClient.get(`/vehicle-types/${id}`);
    return response.data;
};

export const createVehicleType = async (data: CreateVehicleTypeBody): Promise<VehicleTypeResponse> => {
    const response: AxiosResponse<VehicleTypeResponse> = await apiClient.post('/vehicle-types', data);
    return response.data;
};

export const updateVehicleType = async (id: string, data: UpdateVehicleTypeBody): Promise<VehicleTypeResponse> => {
    const response: AxiosResponse<VehicleTypeResponse> = await apiClient.patch(`/vehicle-types/${id}`, data);
    return response.data;
};
